<template>
	<error-page status="403" title="Access denied">
		<p>
			The request was valid, but the server is refusing action.
			You might not have the necessary permissions for this resource.
		</p>
		<btn primary raised :to="{ name: 'home' }">Home</btn>
	</error-page>
</template>


<script>
	export default {
		name: 'forbidden',
		methods: {
			goBack() {
				this.$router.go(-1);
			}
		}
	};
</script>
